module.exports = __webpack_public_path__ + "img/menu-6.5b5376b3.png";